import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PermissionValidationSchema } from '@/features/permissions/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateClientPermissionProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateClientPermission = ({ onSuccess, onError }: UseCreateClientPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createClientPermission'],
    mutationFn: (form: PermissionValidationSchema) => {
      const parsedProperties = form.properties && JSON.parse(form.properties?.replace(/'/g, '"'));

      const permission = {
        ...form,
        operation_klass: form.operation_klass.value,
        properties: parsedProperties
      }

      return privateAxios.post('/client/permissions', permission)
    },
    onSuccess,
    onError,
  })
}

export default useCreateClientPermission
